import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon, FacebookIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
export function Footer() {
  return <footer role="contentinfo" aria-label="Site footer" className="bg-viridia-black border-t border-gray-800 pt-16 pb-8" data-id="element-130">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12" data-id="element-132">
          {/* Column 1: Company Info */}
          <div className="space-y-6 lg:col-span-2" data-id="element-133">
            <Link to="/" className="flex items-center gap-3" data-id="element-134">
              <img src="https://cdn.magicpatterns.com/uploads/dBgonnHgNocdZqWCx2rT29/VA-Logo_(1).png" alt="Viridia Analytics" className="h-10 w-auto object-contain" data-id="element-135" />
              <span aria-hidden="true" className="text-white font-bold text-xl tracking-wide" data-id="element-136">
                VIRIDIA
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-137">
              We help local service businesses stop missing leads, respond
              instantly, and book more jobs. Real systems, real results from
              real Phoenix-area clients.
            </p>
            <div className="flex space-x-4" data-id="element-138">
              <a href="https://www.facebook.com/profile.php?id=61571074363261" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-viridia transition-colors" aria-label="Facebook" data-id="element-139">
                <FacebookIcon className="w-5 h-5" data-id="element-140" />
              </a>
              <a href="https://www.instagram.com/viridiaanalyticsllc/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-viridia transition-colors" aria-label="Instagram" data-id="element-141">
                <InstagramIcon className="w-5 h-5" data-id="element-142" />
              </a>
              <a href="https://www.linkedin.com/company/viridia-analytics/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-viridia transition-colors" aria-label="LinkedIn" data-id="element-143">
                <LinkedinIcon className="w-5 h-5" data-id="element-144" />
              </a>
              <a href="https://www.yelp.com/biz/viridia-analytics-phoenix-2" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#FF1A1A] transition-colors" aria-label="Yelp" data-id="element-145">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-146">
                  <path d="M12.271 6.727c-.236.753-1.528 4.862-1.728 5.46-.126.376-.048.553.089.67.137.116.404.178.74.178h2.168c.337 0 .604-.062.74-.178.138-.117.216-.294.09-.67-.2-.598-1.493-4.707-1.728-5.46-.157-.502-.214-.502-.371 0zM20.844 17.262c-.18.472-.588.816-1.09.916l-3.748.748c-.502.1-.98-.072-1.276-.46l-1.77-2.316c-.296-.388-.32-.916-.064-1.33l1.532-2.484c.256-.414.71-.648 1.212-.624l3.82.148c.502.024.942.308 1.174.756l.21.404zm-5.908 3.688c-.076.5-.39.912-.84 1.1l-3.36 1.404c-.45.188-.952.124-1.34-.172l-2.316-1.77c-.388-.296-.548-.78-.428-1.288l.72-3.04c.12-.508.476-.904.952-1.06l3.608-1.18c.476-.156.988-.04 1.368.308l2.268 2.076c.38.348.444.872.368 1.372l-.5 2.25zM3.156 17.262l.21-.404c.232-.448.672-.732 1.174-.756l3.82-.148c.502-.024.956.21 1.212.624l1.532 2.484c.256.414.232.942-.064 1.33l-1.77 2.316c-.296.388-.774.56-1.276.46l-3.748-.748c-.502-.1-.91-.444-1.09-.916l-.5-2.25c-.076-.5-.012-1.024.368-1.372l.132-.12zM5.988 4.89c.296-.388.774-.56 1.276-.46l3.748.748c.502.1.91.444 1.09.916l.5 2.25c.076.5.012 1.024-.368 1.372l-2.268 2.076c-.38.348-.892.464-1.368.308L5.99 10.92c-.476-.156-.832-.552-.952-1.06l-.72-3.04c-.12-.508.04-.992.428-1.288l1.242-.642zm12.024 0l1.242.642c.388.296.548.78.428 1.288l-.72 3.04c-.12.508-.476.904-.952 1.06l-3.608 1.18c-.476.156-.988.04-1.368-.308L10.766 9.716c-.38-.348-.444-.872-.368-1.372l.5-2.25c.18-.472.588-.816 1.09-.916l3.748-.748c.502-.1.98.072 1.276.46z" data-id="element-147" />
                </svg>
              </a>
              <a href="https://share.google/7uhXXh31DmLvspcqP" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#4285F4] transition-colors" aria-label="Google Business Profile" data-id="element-148">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-149">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" data-id="element-150" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-151" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-152" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-153" />
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-154">
            <h3 className="text-white font-semibold mb-6" data-id="element-155">Quick Links</h3>
            <ul className="space-y-4" data-id="element-156">
              <li data-id="element-157">
                <Link to="/" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-158">
                  Home
                </Link>
              </li>
              <li data-id="element-159">
                <Link to="/about" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-160">
                  About Us
                </Link>
              </li>
              <li data-id="element-161">
                <Link to="/case-studies" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-162">
                  Case Studies
                </Link>
              </li>
              <li data-id="element-163">
                <Link to="/case-studies/tfp-landscaping" className="text-gray-500 hover:text-viridia transition-colors text-sm pl-4" data-id="element-164">
                  - TFP Landscaping
                </Link>
              </li>
              <li data-id="element-165">
                <Link to="/case-studies/finish-coat-painting" className="text-gray-500 hover:text-viridia transition-colors text-sm pl-4" data-id="element-166">
                  - Finish Coat Painting
                </Link>
              </li>
              <li data-id="element-167">
                <Link to="/pricing" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-168">
                  Pricing
                </Link>
              </li>
              <li data-id="element-169">
                <Link to="/contact" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-170">
                  Book a Call
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Services */}
          <div data-id="element-171">
            <h3 className="text-white font-semibold mb-6" data-id="element-172">Services</h3>
            <ul className="space-y-4" data-id="element-173">
              <li data-id="element-174">
                <Link to="/ai-lead-conversion" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-175">
                  AI Lead Conversion
                </Link>
              </li>
              <li data-id="element-176">
                <Link to="/custom-automations" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-177">
                  Custom Automations
                </Link>
              </li>
              <li data-id="element-178">
                <Link to="/crm-business-tools" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-179">
                  CRM & Business Tools
                </Link>
              </li>
              <li data-id="element-180">
                <Link to="/reputation-management" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-181">
                  Reputation Management
                </Link>
              </li>
              <li data-id="element-182">
                <Link to="/ad-campaigns" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-183">
                  Ad Campaigns
                </Link>
              </li>
              <li data-id="element-184">
                <Link to="/web-design-seo" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-185">
                  Web Design & SEO
                </Link>
              </li>
              <li data-id="element-186">
                <Link to="/google-business-profile-setup" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-187">
                  Google Business Profile Setup
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Free Tools */}
          <div data-id="element-188">
            <h3 className="text-white font-semibold mb-6" data-id="element-189">Free Tools</h3>
            <ul className="space-y-4" data-id="element-190">
              <li data-id="element-191">
                <Link to="/tools/gmail-signature-generator" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-192">
                  Gmail Signature Generator
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 5: Contact */}
          <div data-id="element-193">
            <h3 className="text-white font-semibold mb-6" data-id="element-194">Contact Us</h3>
            <ul className="space-y-4" data-id="element-195">
              <li className="flex items-start gap-3" data-id="element-196">
                <PhoneIcon className="w-5 h-5 text-viridia flex-shrink-0 mt-0.5" data-id="element-197" />
                <a href="tel:6233000708" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-198">
                  (623) 300-0708
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-199">
                <MailIcon className="w-5 h-5 text-viridia flex-shrink-0 mt-0.5" data-id="element-200" />
                <a href="mailto:info@viridiaanalytics.com" className="text-gray-400 hover:text-viridia transition-colors text-sm" data-id="element-201">
                  info@viridiaanalytics.com
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-202">
                <MapPinIcon className="w-5 h-5 text-viridia flex-shrink-0 mt-0.5" data-id="element-203" />
                <span className="text-gray-400 text-sm" data-id="element-204">
                  Phoenix, AZ
                  <br data-id="element-205" />
                  Serving Local Businesses
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-206">
          <p className="text-gray-500 text-sm" data-id="element-207">
            © {new Date().getFullYear()} Viridia Analytics. All rights
            reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-208">
            <Link to="/privacy" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-209">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-210">
              Terms of Service
            </Link>
            <a href="/sitemap.xml" className="text-gray-500 hover:text-white text-sm transition-colors" data-id="element-211">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>;
}